































































































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTable from "@/components/form/CustomTable.vue";
import { UserCsvImport as IUserCsvImport } from "@/api/models/user-csv-import";
import { UserEdit as IUserEdit } from "@/api/models/user-edit";
import { UserDocumentInfoEdit as IUserDocumentInfoEdit } from "@/api/models/user-document-info-edit";
import CustomButton from "@/components/form/CustomButton.vue";
import CField from "@/components/form/CField.vue";
import api from "@/getinfo-api";
import { cloneDeep, omitBy, isNil } from "lodash";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import moment from "moment/moment";
import UserAvatar from "@/components/user/UserAvatar.vue";
import FileManager from "@/components/files/FileManager.vue";
import { FileItem as IFileItem } from "@/api/models";
import { screenWidth } from "@/plugins/variables";

@Component({
  components: {
    FileManager,
    UserAvatar,
    CField,
    CustomButton,
    CustomTableCol,
    CustomTableItem,
    CustomTable
  }
})
export default class ImportedUsersItem extends Vue {
  @Prop() item?: IUserCsvImport;
  @Prop({ default: false }) highlighted?: boolean;
  user!: IUserEdit;
  selectedUserPhoto!: IFileItem | null;
  isShowFileManager: boolean = false;
  userDocumentInfo!: IUserDocumentInfoEdit;
  isChecked: boolean = false;

  data() {
    return {
      user: undefined,
      userDocumentInfo: undefined,
      selectedUserPhoto: this?.item?.user?.photo
        ? this.item.user?.photo
        : undefined
    };
  }

  selectFile(file: IFileItem) {
    this.selectedUserPhoto = file;
    if (this.screenWidth < 992) {
      this.isShowFileManager = false;
    }
    this.user.photoId = this.selectedUserPhoto?.id
      ? this.selectedUserPhoto?.id
      : null;
    this.saveUser();
  }

  get screenWidth() {
    return screenWidth();
  }

  fileDelete() {
    this.selectedUserPhoto = null;
    this.user.photoId = null;
    this.saveUser();
  }

  saveUser() {
    if (this.item?.user) {
      // let _user = omitBy(this.user, isNil);
      if (!this.user.phone) {
        this.user.phone = "";
      }
      //@ts-ignore
      if (this.user.photo) {
        //@ts-ignore
        this.user.photoId = this.user.photo.id;
        //@ts-ignore
        delete this.user.photo;
      }
      api.UsersApi.edit(this.item?.user?.id, this.user)
        .then(res => {
          this.user = cloneDeep(res.data);
          //@ts-ignore
          this.user.birthday =
            this.item?.user && res.data?.birthday
              ? //@ts-ignore
                moment(res.data.birthday).format("YYYY-MM-DD")
              : undefined;

          this.$emit("saveUser", res.data);
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  saveUserDocumentInfo() {
    if (this.item?.userDocumentInfo?.userId) {
      api.UsersApi.editDocumentInfo(
        this.item?.userDocumentInfo?.userId,
        this.userDocumentInfo
      )
        .then(res => {
          this.userDocumentInfo = cloneDeep(res.data);
          this.$emit("saveUserDocumentInfo", res.data);
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  created() {
    this.user = cloneDeep(this.item?.user) as IUserEdit;
    //@ts-ignore
    this.user.photoId = this.item?.user?.photo?.id ?? undefined;

    //@ts-ignore
    this.user.birthday =
      this.item?.user && this.item?.user.birthday
        ? //@ts-ignore
          moment(this.user.birthday).format("YYYY-MM-DD")
        : undefined;
    this.userDocumentInfo = cloneDeep(
      this.item?.userDocumentInfo
    ) as IUserDocumentInfoEdit;
  }
}
